// The "Run this on your page" intent saved from the example report: kept on the user
// (pendingFirstRun, server side) and mirrored in the signup store for the plan pages.

export function normalizePageUrl (value) {
  const trimmed = (value || '').trim()
  if (!trimmed) return ''
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
}

export function isValidPageUrl (value) {
  try {
    const parsed = new URL(normalizePageUrl(value))
    return Boolean(parsed.hostname) && parsed.hostname.includes('.') && !parsed.hostname.endsWith('.')
  } catch (e) {
    return false
  }
}

export function pendingFirstRun (store) {
  const user = store.state.user || {}
  const saved = user.pendingFirstRun
  if (saved && saved.url && saved.keyword) return { url: saved.url, keyword: saved.keyword }
  const local = store.state.signup && store.state.signup.firstRun
  if (local && local.url && local.keyword) return { url: local.url, keyword: local.keyword }
  return null
}

/** Where to land once a plan is active: the prefilled first run when one was saved, else the dashboard. */
export function afterPlanRoute (store) {
  const run = pendingFirstRun(store)
  if (!run) return '/sites'
  return { path: '/newsite', query: { url: run.url, keyword: run.keyword, firstRun: '1' } }
}
